module.exports = __webpack_public_path__ + "static/media/logo_saastainer.6c4e08db.png";